import React from 'react';
import { Form, Button } from 'tabler-react';

const CheckboxOption = ({
  onChange, endedState, ended,
}) => (
  <Form.Radio
    checked={endedState === ended}
    label={endedState ? 'Ended' : 'Active'}
    name="ended"
    value={endedState}
    onChange={onChange}
  />
);

const EndedOptions = ({
  onClear, handleSelectEnded, ended: currentEnded,
}) => (
  <Form.Group label="Ended">
    <CheckboxOption ended={currentEnded} endedState={false} onChange={() => handleSelectEnded({ ended: false })} />
    <CheckboxOption ended={currentEnded} endedState onChange={() => handleSelectEnded({ ended: true })} />
    <Button onClick={onClear} color="secondary">Clear</Button>
  </Form.Group>
);

export default EndedOptions;



// WEBPACK FOOTER //
// ./src/components/EndedSelect.js